import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ActivityIcon = createIcon({
  displayName: 'ActivityIcon',
  path: (
    <>
      <path stroke='none' d='M0 0h24v24H0z' />
      <path d='M3 12h4l3 8 4-16 3 8h4' />
    </>
  ),
  defaultProps: {
    ...defaultProps,
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }
})
